import { Button } from '@art-of-hospitality-solutions-llc/ui-kit/components/button';
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import type { Flow } from '@Types/flow';
import { cn } from '@Utils/cn';
import { formatDate } from '@Utils/utils';

export interface FlowListCardProps {
  flow: Flow;
  className?: string;
}

export function FlowCard({ flow, className }: FlowListCardProps) {
  return (
    <div
      data-slot="flow-list-card"
      className={cn(
        'relative flex min-w-fit items-center overflow-hidden rounded-xl border border-zinc-200 bg-white shadow-xs',
        className,
      )}
    >
      <div className="absolute top-0 left-0 h-full w-1 bg-[#caab6a]" />

      <div className="flex min-w-0 flex-1 items-center justify-between gap-6 py-4 pr-4 pl-7">
        <div className="flex min-w-0 shrink-0 flex-col gap-1.5">
          <p className="text-lg leading-7 text-zinc-800">{flow.flowTitle}</p>
          <p className="text-sm leading-none text-zinc-500">
            Created: {formatDate(flow.createdAt)}
          </p>
        </div>

        <Button asChild>
          <Link to={`/flows/builder?id=${flow.id}`}>
            Manage flow
            <ArrowRight className="ml-1 size-4" />
          </Link>
        </Button>
      </div>
    </div>
  );
}
